import {getDate, getKeyTitle} from "../js/tool";

export const driverColumns = [
    {title: '姓名', dataIndex: 'name'},
    {title: '手机号码', dataIndex: 'tel'},
]

export const passColumns = [
    {title: '通行证类型', dataIndex: 'type'},
    {title: '有效期', dataIndex: 'valid_start_time', customRender: (text, record) => `${getDate(text).pattern("yyyy-MM-dd HH:mm")} 至 ${getDate(record.valid_end_time).pattern("yyyy-MM-dd HH:mm")}`},
]

export const vehicleColumns = [
    {title: '车牌号', dataIndex: 'car_number'},
    {title: '车辆类型', dataIndex: 'car_type', customRender: text => getVehicleTypeText(text)},
    {title: '车辆品牌', dataIndex: 'brand'},
    {title: '座位数', dataIndex: 'seats', customRender: text => text + '座'},
    {title: '司机姓名', dataIndex: 'driver_name', customRender: (text, record) => record.driver ? record.driver.name : '未匹配'},
    {title: '手机号', dataIndex: 'driver_tel', customRender: (text, record) => record.driver ? record.driver.tel : '未匹配'},
    {title: '车辆通行证', dataIndex: 'pass', customRender: (text, record) => record.passCheck ? record.passCheck.type : '未设置'},
]

export const vehicleTypeList = [
    {key: 1, title: '轿车'},
    {key: 2, title: '商务车'},
    {key: 3, title: '大巴'},
]

export const getVehicleTypeText = function (type) {
    return getKeyTitle(vehicleTypeList, type);
}
